import type { GridColDef } from '@mui/x-data-grid';
import { MAX_TO } from '@weft/types';
import { formatNumber, purge } from '@weft/utils';
import cn from 'classnames';
import { INFINITY_SYMBOL } from '../../../../../../../assets/components/design/symbols/infinity-symbol';
import { EditTiersTablePerUnitCellField } from './usage-product-variant-table-edit-components/EditTiersTablePerUnitCellField';
import { EditTiersTablePerUnitColumn } from './usage-product-variant-table-edit-components/EditTiersTablePerUnitColumn';
import type { UsageProductVariantTableRow } from './usage-product-variant-table-edit-types/usage-product-variant-table-row';

export const getEditTierTableColumns = (
  isVolumeProduct: boolean,
  isRevShareProduct: boolean,
  isTieredSubscriptionProduct: boolean,
  isFlatRate: boolean,
): GridColDef<UsageProductVariantTableRow>[] => {
  return purge([
    {
      field: 'from',
      headerName: 'From',
      flex: 1,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      sortable: false,
      renderCell: ({ value, row }) => (
        <span className={cn('font-sans text-black text-base', {
          'text-gray': row.from === 1 && row.index === 0,
        })}
        >
          {formatNumber(value)}
        </span>
      ),
    },
    {
      field: 'to',
      headerName: 'To',
      flex: 1,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      sortable: false,
      renderCell: ({ value }) => <span className="font-sans text-base text-black">{getToDisplayValue(value)}</span>,
    },
    isFlatRate ? {
      field: 'flatRate',
      headerName: isTieredSubscriptionProduct ? 'Fixed Rate' : 'Flat Rate',
      flex: 1,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      sortable: false,
      renderCell: ({ row }) => (
        <EditTiersTablePerUnitColumn
          value={row.flatRate}
          row={row}
          isFlatRateColumn
          isTieredSubscriptionProduct={isTieredSubscriptionProduct}
        />
      ),
    } : undefined,
    !isTieredSubscriptionProduct ? {
      field: 'price',
      headerName: getHeaderName(isVolumeProduct, isRevShareProduct),
      flex: 1,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      sortable: false,
      cellClassName: 'px-0',
      renderCell: ({ value, row }) => (
        <EditTiersTablePerUnitColumn
          value={value}
          row={row}
          isRevShareProduct={isRevShareProduct}
        />
      ),
      renderEditCell: ({ id, field, api, value }) => (
        <EditTiersTablePerUnitCellField
          id={id}
          field={field}
          api={api}
          value={value}
        />
      ),
    } : undefined,
  ]);
};

export function getToDisplayValue(value: number) {
  return value === MAX_TO ? INFINITY_SYMBOL : formatNumber(value);
}

function getHeaderName(isVolumeProduct: boolean, isRevShareProduct: boolean) {
  if (isVolumeProduct) {
    return 'Volume Price';
  }

  if (isRevShareProduct) {
    return 'Price rate';
  }

  return 'Price';
}